module.exports = __webpack_public_path__ + "media/images/404-6b6396d0f97bb429bc007cc76b44dd12.png";